import { fetchAggregators } from 'api/fetchers/get-aggregators';
import useSWR from 'swr';
import swrConfig from 'utils/swrConfig';
import { AggregatorsResponse } from '../../pb/responses/v1/aggregators_response_pb';

export const useAggregatorsSWR = () => {
    const { data, isLoading, error } = useSWR<AggregatorsResponse>('aggregators', fetchAggregators, swrConfig);

    return { data, isLoading, error };
};
